<template>
    <div :class="divWrapper" v-on-clickaway="clickAway">
        <div :class="[divSelected, { active: isActive }]" @click="toggleActive">
            {{ title }}
        </div>
        <div :class="divItems">
            <div :class="divItem" @click="changeSelected">
                {{ defaultTitle }}
            </div>
            <div
                :class="divItem"
                v-for="(item, index) in listItems"
                :key="index"
                @click="changeSelected(index, $event)"
            >
                <template v-html="item.name">{{ item.name }}</template>
            </div>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
    name: "SearchList",
    emits: ["submit-list"],
    props: {
        className: { type: String, default: "custom-select" },
        listTitle: String,
        listItems: Array,
        makeEmpty: Boolean,
    },
    mixins: [clickaway],
    data() {
        return {
            selected: "",
            defaultTitle: this.listTitle,
            title: this.listTitle,
            isActive: false,
        };
    },
    computed: {
        divWrapper() {
            return `${this.className}--select`;
        },
        divSelected() {
            return `${this.className}--select__selected`;
        },
        divSearch() {
            return `${this.className}--select__search`;
        },
        divItems() {
            return `${this.className}--select__items`;
        },
        divItem() {
            return `${this.className}--select__item`;
        },
    },
    watch: {
        makeEmpty(val) {
            if (!val) return;
            this.selected = "";
            this.title = this.defaultTitle;
            this.submitData();
        },
    },
    methods: {
        haveLink(n) {
            const link = this.listItems[n].link;
            return link ? link.indexOf("taxonomy") > -1 : -1;
        },
        toggleActive() {
            this.isActive = !this.isActive;
        },
        clickAway() {
            this.isActive = false;
        },
        changeSelected(idx, event) {
            const link = this.listItems[idx].link;

            if (link.length > 1)
                return (window.location.href = link);

            const result = event.target.innerText.trim();
            this.title = result;

            result === this.defaultTitle
                ? (this.selected = "")
                : (this.selected = result);

            this.submitData();
            this.toggleActive();
        },
        updatedSelectedFromURL(urlData) {
            this.selected = urlData;
            this.title = urlData;
            this.submitData();
        },
        submitData() {
            this.$emit("submit-list", this.selected);
        },
    },
};
</script>

<style lang="less">
@body: "Muli", "Microsoft JhengHei", "微軟正黑體", sans-serif;
@mobile: ~"only screen and (max-width: 767px)";
@tablet: ~"only screen and (min-width: 768px) and (max-width: 999px)";
.translateFont() {
    &:lang(zh-hant),
    &:lang(zh-hans) {
        font-size: 18px;
    }
}
.customScrollBar(@bgcolor: white, @barcolor: #939598) {
    //for Chrome
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        -webkit-appearance: none;
    }
    /* Handle */
    &::-webkit-scrollbar:vertical {
        width: 6px;
    }

    &::-webkit-scrollbar:horizontal {
        height: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: @barcolor;
        border-radius: 10px;
        cursor: grab;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: darken(@barcolor, 10%);
    }
    //for Firefox
    scrollbar-width: thin;
    scrollbar-color: @barcolor transparent;
    //for IE
    scrollbar-face-color: @barcolor;
    scrollbar-arrow-color: @bgcolor;
    scrollbar-track-color: @bgcolor;
    scrollbar-shadow-color: transparent;
    scrollbar-highlight-color: @barcolor;
    scrollbar-3dlight-color: transparent;
    scrollbar-darkshadow-color: transparent;
}

.qualifications,
.stage {
    &--select {
        // width: 100%;
        width: 300px;
        margin: 0 7.5px 15px;
        position: relative;
        color: grey;

        &__items {
            .customScrollBar();
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background-color: white;
            overflow-y: overlay;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
            width: calc(100% - 22px);
            z-index: 1000;
            min-width: 160px;
            padding: 10px;
            margin: 2px 0;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 4px;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
        }
        &__item {
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 7px 5px;
            margin-right: 5px;
            font-size: 16px;
            font-style: italic;
            line-height: 1.2em;
            color: black;
            transition: 0.3s all ease;

            &:first-child {
                color: #6d6e71;
            }
            &:hover {
                transition: 0.3s all ease;
                background: #f5f5f5;
            }
            a {
                text-decoration: none;
                color: black;
            }
        }
        &__selected {
            cursor: pointer;
            position: relative;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            width: 100%;
            height: 45px;
            padding: 5px 50px 5px 10px;
            background: #f1f1f1;
            font-family: @body;
            color: black;
            font-size: 20px;
            font-style: italic;
            // white-space: nowrap;

            @media @mobile {
                height: 40px;
                padding: 5px 50px 5px 10px;
                font-size: 16px;
            }

            &:before {
                transition: 0.3s all ease;
                transform: rotate(45deg);
                content: "";
                position: absolute;
                right: 14px;
                top: 10px;
                border: solid black;
                border-width: 0 1px 1px 0;
                width: 15px;
                height: 15px;
                z-index: 1;
                pointer-events: none;

                @media @mobile {
                    right: 13px;
                    top: 28%;
                    width: 12px;
                    height: 12px;
                }
            }
            &:after {
                content: "";
                position: absolute;
                background-color: #ffcc32;
                width: 45px;
                min-height: 45px;
                height: 100%;
                right: 0;
                top: 0;
                z-index: 0;
                pointer-events: none;
                @media @mobile {
                    width: 40px;
                    min-height: 40px;
                }
            }
            &.active {
                ~ .qualifications--select__items,
                ~ .stage--select__items {
                    opacity: 1;
                    visibility: visible;
                    max-height: 270px;
                }
            }
        }
        @media @mobile {
            width: 100%;
            margin: 0 0 15px;
        }
    }
}
</style>
